import { saveState, getSavedState } from '@utils/browser-help'
import moment from 'moment'
import { debounce } from 'lodash'

export default {
  components: {},
  filters: {},
  data() {
    return {
      minutes: 0,
      seconds: 0,
      timer: null,
      isExpired: false,
      tempTimePeriodInMixin: 5,
      payListStop: false, // 付款停止
    }
  },
  computed: {
    /**
     * @description 是否有容器是未付款並且正在卡單狀態
     */
    childrenContainerUnpaidAndTemp() {
      const { childrenOrderContainers } = this.containerOrders
      let hasTempAndUnpaidChild = false // 是否有未付款+卡單狀態結束的容器
      if (childrenOrderContainers.items.length > 0) {
        hasTempAndUnpaidChild = childrenOrderContainers.items.some((item) => {
          // 要先把未付款的通通都付款完後，才可以繼續新增子訂單
          return item.is_temp === 0 && item.paymentStatus === 'UNPAID' && item.cancel_at === ''
        })
      }
      return hasTempAndUnpaidChild
    },
    /**
     * @description 是否有容器是未付款並且正在卡單狀態
     */
    isParentContainerTemp() {
      if (this.containerOrders && Object.keys(this.containerOrders).length > 0) {
        return this.containerOrders.is_temp === 1
      }
    },
    /**
     * @description 如果是0元，就直接預約完成
     */
    directPayText() {
      if (this.paidAndUnPaidSummary['unPaid'] === 0 && this.containerOrders.paymentStatus === 'UNPAID' && this.haveNewOrder === 0) {
        return '預約完成'
      } else {
        return '前往付款'
      }
    },
    /**
     * @description 測試是否有包月尚未付款
     */
    testPrepaidOrderNotCheck() {
      try {
        if (Object.keys(this.containerOrders).length > 0 && this.containerOrders.is_temp === 0) {
          const { orders } = this.containerOrders
          return orders.some((item) => item.prepaidOrderStatus === 2)
        }
        return false
      } catch (error) {
        console.error(error.message)
      }
    },
    /**
     * @description 計算container 的params付款以及未付款的錢
     */
    containerParamsPayTotal() {
      try {
        let totalType = {
          unPaid: 0,
          paid: 0,
          total: 0,
        }
        if (Object.keys(this.containerOrders).length > 0) {
          // 母 container params 的加總
          this.containerOrders.params.forEach((item) => {
            totalType['total'] = totalType['total'] + item.total
            if (item.paymentStatus === 'UNPAID') {
              totalType['unPaid'] = totalType['unPaid'] + item.total
            }
            if (item.paymentStatus === 'PAID') {
              totalType['paid'] = totalType['paid'] + item.total
            }
          })
          const { items } = this.containerOrders.childrenOrderContainers
          // 子 container params 的加總
          items.forEach((innerItem1) => {
            const { params } = innerItem1
            params.forEach((paramsItem) => {
              if (paramsItem.paymentStatus === 'UNPAID') {
                totalType['unPaid'] = totalType['unPaid'] + paramsItem.total
              }
              if (paramsItem.paymentStatus === 'PAID') {
                totalType['paid'] = totalType['paid'] + paramsItem.total
              }
            })
          })
        }
        // totalType.unPaid = totalType.unPaid < 0 ? 0 : totalType.unPaid;
        totalType.paid = totalType.paid < 0 ? 0 : totalType.paid
        totalType.total = totalType.total < 0 ? 0 : totalType.total
        return totalType
      } catch (error) {
        console.error(error.message)
      }
    },
    /**
     * @description 計算子訂單與母訂單 尚未付款以及付款的錢
     */
    normalOrderPaidAndUnpaid() {
      try {
        let init = {
          paid: 0,
          unPaid: 0,
        }
        const computedMoney = (accum, item) => {
          if (item.paymentStatus === 'UNPAID' || item.paymentStatus === null) {
            accum['unPaid'] = accum['unPaid'] + item.payTotal
          }
          if (item.paymentStatus === 'PAID') {
            accum['paid'] = accum['paid'] + item.payTotal
          }
          return accum
        }
        if (Object.keys(this.containerOrders).length > 0) {
          const { orders } = this.containerOrders
          init = orders.reduce((accum, curr) => {
            accum = computedMoney(accum, curr)
            if (curr.childrenOrders.length > 0) {
              curr.childrenOrders.forEach((item) => {
                accum = computedMoney(accum, item)
              })
            }
            return accum
          }, Object.assign({}, init))
        }
        return init
      } catch (error) {
        console.error(error.message)
      }
    },
    /**
     * @description 整個(包含母子訂單與container(params))付款與未付款的錢
     */
    paidAndUnPaidSummary() {
      return {
        paid: this.containerParamsPayTotal['paid'] + this.normalOrderPaidAndUnpaid['paid'],
        unPaid: this.containerParamsPayTotal['unPaid'] + this.normalOrderPaidAndUnpaid['unPaid'],
      }
    },
    /**
     * @description 左側寵物/訂單加購列表(選擇單一訂單部分)
     * output type -> Array
     */
    containerParentIdNullOrder() {
      try {
        let unpaidArr = []
        if (Object.keys(this.containerOrders).length > 0) {
          const { orders } = this.containerOrders
          orders.forEach((orderDetail) => {
            const { childrenOrders } = orderDetail
            // 找出未付款子訂單
            // const childUnpaidOrders = childrenOrders.filter(item => item.paymentStatus === 'UNPAID' && item.paymentMethod === null && item.pet !== null)
            const childUnpaidOrders = childrenOrders.filter((item) => item.paymentStatus === 'UNPAID' && item.pet !== null)
            // 放入母訂單
            if (orderDetail.paymentStatus === 'UNPAID' && orderDetail.pet !== null) {
              unpaidArr.push(orderDetail)
            }
            if (childUnpaidOrders.length > 0) {
              unpaidArr = [...unpaidArr, ...childUnpaidOrders]
            }
          })
          return unpaidArr
        } else {
          return []
        }
      } catch (error) {
        console.error(error.message)
      }
    },
    /**
     * @description 找出哪個是未付款的container
     */
    testUnpaidContainer() {
      try {
        let unPaidDetail = {
          parentUuid: '',
          parentInvoiceStatus: -1,
          childInvoiceStatus: -1,
          childUuid: '',
          status: false,
          childTotal: 0,
          parentTotal: 0,
          parentCanPayByDeposit: true,
          childCanPayByDeposit: true, // 未來當加購也有deposit時，這裡要做增加條件
        }
        const { orders } = this.containerOrders
        if (!orders) {
          return unPaidDetail
        }
        // 找父層未付款的containerID && 發票狀態
        // 要找到的是，未取消並且未付款的訂單
        const filterNotCancelAndUnpaidOrder = (item) => {
          return (item.paymentStatus === 'UNPAID' || !item.paymentStatus) && item.status !== 0
        }
        let unpaidParentItem = orders.find((item) => filterNotCancelAndUnpaidOrder(item))
        if (unpaidParentItem && Object.keys(unpaidParentItem).length > 0) {
          unPaidDetail['parentUuid'] = unpaidParentItem.orderContainerUuid
          unPaidDetail['status'] = true
          unPaidDetail['parentOrderId'] = unpaidParentItem.orderContainerDisplayId
          unPaidDetail['parentInvoiceStatus'] = orders[0]['storeInvoiceSetting']
          unPaidDetail['parentCanPayByDeposit'] = this.containerOrders['canPayByDeposit']
        }
        // 找子層未付款的containerID
        if (!unPaidDetail['status']) {
          orders.forEach((item) => {
            const { childrenOrders } = item
            if (!unPaidDetail['status'] && childrenOrders.length > 0) {
              let unpaidChildItem = childrenOrders.find((item) => filterNotCancelAndUnpaidOrder(item))
              if (unpaidChildItem) {
                unPaidDetail['childUuid'] = unpaidChildItem.orderContainerUuid
                unPaidDetail['status'] = true
                unPaidDetail['childOrderId'] = unpaidChildItem.orderContainerDisplayId
                unPaidDetail['childInvoiceStatus'] = childrenOrders[0]['storeInvoiceSetting']
              }
            }
            childrenOrders.forEach((item) => {
              if (filterNotCancelAndUnpaidOrder(item)) {
                unPaidDetail['childTotal'] = unPaidDetail['childTotal'] + item.payTotal
              }
            })
          })
        }
        return unPaidDetail
      } catch (error) {
        console.error(error.message)
      }
    },
    /**
     * @description 用寵物進行服務分類
     */
    serviceCountByPet() {
      if (Object.keys(this.containerOrders).length > 0) {
        const { orders: objects } = this.containerOrders
        const categorizedObjects = objects.reduce((result, obj) => {
          const category = obj.pet.id
          if (!result[category]) {
            result[category] = []
          }
          result[category].push(obj)
          return result
        }, {})
        return categorizedObjects
      } else {
        return {}
      }
    },
    /**
     * @description 左側寵物tab列表（新增for ReservationOrderDetail.vue）
     * output type -> Array
     */
    containerGroupPetIdForDetail() {
      try {
        const { orders } = this.containerOrders
        if (orders && orders.length > 0) {
          return this.orderPet(orders)
        } else {
          return []
        }
      } catch (error) {
        console.error(error.message)
      }
    },
    /**
     * @description 左側寵物tab列表（新增for ReservationOrderForm.vue）
     * output type -> Array
     */
    containerGroupPetId() {
      try {
        let result = []
        if (Object.keys(this.memberInfo).length > 0 && this.memberInfo.hasOwnProperty('orderContainers')) {
          const { items } = this.memberInfo.orderContainers
          items.forEach((itemDetail) => {
            const { orders } = itemDetail
            result = this.orderPet(orders)
          })
          return result
        } else {
          return []
        }
      } catch (error) {
        console.error(error.message)
      }
    },
  },
  watch: {},
  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    /**
     * @description 取得美容服務基本設定
     */
    async getCosmeticBasicToSetTempTime() {
      try {
        const { response } = await this.$store.dispatch('merchant/getCosmeticBasicSet', {
          type: 'cosmetic',
        })
        this.tempTimePeriodInMixin = response.items.tempTimePeriod
      } catch (error) {
        console.error(error.message)
      }
    },
    /**
     * @descriptionn 負數先return
     */
    async negativeAlert(price) {
      const isNegative = price < 0
      // 金額負數要先提醒
      if (isNegative) {
        this.$confirm('訂單金額不能小於0', '提醒', {
          confirmButtonText: '確定',
          showCancelButton: false,
          type: 'warning',
          center: true,
        })
        return new Promise((resolve, reject) => reject())
      } else {
        return new Promise((resolve, reject) => resolve(true))
      }
    },
    /**
     * @description 計算倒數計時
     */
    computedOrderOverTime() {
      try {
        if (this.containerOrders.is_temp === 0) return
        if (Object.keys(this.containerOrders).length > 0) {
          const { updated_at: updatedAt } = this.containerOrders
          // 設定結束時間為起始時間加五分鐘
          let endTime = moment(updatedAt).add(this.tempTimePeriodInMixin, 'minutes')
          // 取得本地與伺服器時間差
          const diffTime = parseInt(localStorage.getItem('diffTime') || 0) / 1000
          let diffMin = 0
          let diffSec = 0
          if (diffTime) {
            diffMin = Math.floor(diffTime / 60)
            diffSec = diffTime % 60
          }
          console.log(diffTime)
          clearInterval(this.timer)
          // 每秒更新計時器
          this.timer = setInterval(async () => {
            // 取得當前時間
            let currentTime = moment()
              .add(diffMin, 'minutes')
              .add(diffSec, 'seconds')
            // 計算距離結束時間還有多少時間
            const duration = moment.duration(endTime.diff(currentTime))
            this.minutes = duration.minutes()
            this.seconds = duration.seconds()
            if (this.minutes <= 0 && this.seconds <= 0 && !this.isExpired) {
              this.isExpired = true
              this.minutes = 0
              this.seconds = 0
              await this.$alert('保留時間到期，請重新新增訂單', {
                confirmButtonText: '確認',
                center: true,
                beforeClose: (action, instance, done) => {
                  this.canAddNewOrder = false
                  this.$emit('closeAndReload')
                  this.$emit('store')
                  clearInterval(this.timer)
                  done()
                },
              })
            }
          }, 1000) // 每秒更新一次
        }
      } catch (error) {
        console.error(error.message)
      }
    },
    /**
     * @description 關閉發票視窗 && 往下繼續走結帳
     */
    closeSignaturDialog(type, submitData) {
      if (type === 'finish') {
        this.signResolveFunc(submitData)
      }
      if (type === 'previous') {
        this.signRejectFunc()
      }
      this.signDialogVisible = false
    },
    /**
     * @description 從payList打開發票視窗
     */
    showSignDialogFromPayList(resolveFunc, rejectFunc) {
      this.signResolveFunc = resolveFunc
      this.signRejectFunc = rejectFunc
      this.startTab = 2
      this.signDialogVisible = true
    },
    /**
     * @description clickTab之後，要找尋現在看的是哪個寵物
     */
    handleClickPetTabMixin(arr, type) {
      try {
        let mixinActiveName = 0
        mixinActiveName = +this.activeName
        if (type === 'detail') {
          //  mixinActiveName = mixinActiveName
        }
        if (type === 'noPlus') {
          mixinActiveName = +mixinActiveName - 1
        }
        if (arr.length > 0) {
          const { id } = arr[+mixinActiveName]
          this.$set(this.submitData, 'petId', id)
        }
      } catch (error) {
        console.error(error.message)
      }
    },
    /**
     * @description update left Pet Tab Info
     */
    updateActiveName(nvl) {
      this.activeName = nvl
    },
    orderPet(orders) {
      let petTabInfo = []
      orders.forEach((orderDetail) => {
        const { pet } = orderDetail
        // 最後如果pet有資訊，以及未曾被加入過陣列，即push進入陣列
        if (pet && Object.keys(pet).length > 0 && petTabInfo.findIndex((tabItem) => tabItem.id === pet.id) === -1) {
          petTabInfo.push({
            name: pet.name,
            avatar: pet.avatar || '',
            id: pet.id,
          })
        }
      })
      return petTabInfo
    },
    /**
     * @description 付款方式的返回
     */
    backToInfo() {
      this.$emit('closeBtnShowFunc', true)
      this.checkResultAndPayStatus = false
    },
    /**
     * @description 儲值金餘額不足，是否加值
     */
    async isDepositInsufficientAlertWindow() {
      await this.$confirm(`儲值金餘額不足，是否加值`, '提醒', {
        confirmButtonText: '確定',
        type: 'warning',
        center: true,
      })
    },
    /**
     * @description deposit付款（from 子組件）
     */
    async paymentMethodDeposit(mainOrderTotal, cb) {
      try {
        this.paymentWay = 'Deposit'
        const isDepositInsufficient = this.depositReduce < mainOrderTotal
        // 點數不充足
        if (isDepositInsufficient) {
          await this.isDepositInsufficientAlertWindow()
          this.createDepositOrderVisible = true
          return
        }
        // 點數充足&&有新訂單
        if (!isDepositInsufficient && this.haveNewOrder > 0) {
          await this.storeSingleOrder(cb)
        }
        // 點數充足&&沒有新訂單
        if (!isDepositInsufficient && this.haveNewOrder === 0) {
          await cb()
        }
      } catch (error) {
        console.error(error.message)
      }
    },
    /**
     * @description 此筆container結帳成功，跳出drawer
     */
    async checkOutSuccess() {
      await saveState('containerMemberId', '')
      this.$emit('closeBtnShowFunc', true)
      this.$emit('store')
      this.$emit('forTabProductSaveSuccessAndClose')
    },
    /**
     * @description 確認填寫，然後跳到結帳畫面（線下付款、線上付款、儲值點數抵扣）
     */
    async checkResultAndPay() {
      try {
        if (this.containerOrders.paymentMethod === 'Installment') {
          this.checkResultAndPayStatus = true
        } else {
          await this.$refs.reserveForm.validate() // 先驗證是否可以往下走
          if (this.paidAndUnPaidSummary['unPaid'] === 0 && this.containerOrders.paymentStatus === 'UNPAID' && this.haveNewOrder === 0) {
            await this.directPay()
          } else {
            this.checkResultAndPayStatus = true
            this.$emit('closeBtnShowFunc', false)
          }
        }
      } catch (error) {
        console.error(error.message)
      }
    },
    /**
     * @description 如果付款金額是0元 && UNPAID -> 就直接打API
     */
    directPay: debounce(async function() {
      try {
        let data = {
          uuid: this.containerOrders.uuid,
          paymentMethod: 'Cash',
          paymentStatus: 'PAID',
          allowExpired: 0,
          total: 0,
          ...this.payPersonInfo,
        }
        const result = await this.$store.dispatch('order/storeContainerId', data)
        if (result.code === 200) {
          this.$message({
            type: 'success',
            message: '儲存成功',
          })
          await this.checkOutSuccess()
        }
      } catch (error) {
        console.error(error.message)
      }
    }, 300),
    /**
     * @description 付款人的資料
     */
    updatePayPersonInfo(nvl) {
      this.payPersonInfo = nvl
    },
    /**
     * @description 反向找尋activeName是哪個
     */
    handleClickPetTabReverse(type) {
      try {
        let arr = []
        if (type === 'add') {
          arr = this.containerGroupPetId
        } else {
          arr = this.containerGroupPetIdForDetail
        }
        const { petId } = this.submitData
        if (petId) {
          const index = arr.findIndex((item) => item.id === petId)
          if (index > -1) {
            this.activeName = `${index + 1}`
          }
        }
      } catch (error) {
        console.error(error.message)
      }
    },
    /**
     * @description 所有寵物的服務資料
     * @returns
     */
    findPetServiceGroupForAll() {
      try {
        let petServiceGroup = []
        if (Object.keys(this.containerOrders).length > 0) {
          const { orders } = this.containerOrders
          // 然後內層orders又是一次回圈
          orders.forEach((orderDetail) => {
            const { pet, params, scheduleItem, date, time, parentId } = orderDetail
            if (!parentId) {
              const { name: petName } = pet
              petServiceGroup.push(Object.assign({}, params[0], scheduleItem, { date, time, petName, orderDetail }))
            }
          })
          petServiceGroup.forEach((item) => {
            let normal = ['cosmetic', 'daycare']
            let typeName = ''
            if (normal.includes(item.type)) {
              typeName = '服務項目'
            }
            item.contTitle = `${typeName}: ${item.title}`
            item.editAssistantEnabled = false
            this.$set(item.orderDetail, 'specifyVisible', false)
          })
          this.petServiceGroupList = petServiceGroup
        } else {
          return []
        }
      } catch (error) {
        console.error(error.message)
      }
    },
    initAssistIdName() {
      return [
        {
          id: '',
          name: '',
        },
      ]
    },
    /**
     * @description 找尋寵物的服務群組
     */
    findPetServiceGroup() {
      try {
        let petServiceGroup = []
        if (Object.keys(this.containerOrders).length > 0) {
          const { orders } = this.containerOrders
          // 然後內層orders又是一次回圈
          orders.forEach((orderDetail) => {
            // 如果沒有助理or空間，先幫他新增一個空的

            if (!Object.keys(orderDetail).includes('spaceHelpers')) {
              this.$set(orderDetail, 'spaceHelpers', [])
            }
            if (!Object.keys(orderDetail).includes('helpers')) {
              this.$set(orderDetail, 'helpers', [])
            }
            if (orderDetail.helpers.length === 0 && !orderDetail.helper) {
              orderDetail.helpers = this.initAssistIdName()
            }
            if (orderDetail.spaceHelpers.length === 0) {
              orderDetail.spaceHelpers = this.initAssistIdName()
            }
            const { pet, params, id: orderId, scheduleItem, date, time, parentId } = orderDetail
            params[0]['orderId'] = orderId
            if (pet && +pet.id === +this.submitData.petId && !parentId) {
              const { name: petName } = pet
              petServiceGroup.push(Object.assign({}, params[0], scheduleItem, { date, time, petName, orderDetail }))
            }
          })
          petServiceGroup.forEach((item) => {
            let normal = ['cosmetic', 'daycare']
            let typeName = ''
            if (normal.includes(item.type)) {
              typeName = '服務項目'
            }
            item.contTitle = `${typeName}: ${item.title}`
            item.editAssistantEnabled = false
            item.editSpaceEnabled = false
            this.$set(item.orderDetail, 'specifyVisible', false)
          })
          this.petServiceGroupList = petServiceGroup
        } else {
          return []
        }
      } catch (error) {
        console.error(error.message)
      }
    },
  },
}
